<script>
    import { token } from "./store/token.js";
    import { fetch_user_list } from "./api/request";

    (async () => {
        const user_list = await fetch_user_list($token);
        console.log(user_list);
    })();

    /*const fetch_user_list = (async () => {
      const response = await fetch(
        "https://staging.api.control.vollume.com/admin/user/list",
        "http://localhost:1337/admin/user/list",
        {
          headers: {
            Authorization: "Bearer " + $token
          }
        }
      );
      user_list = await response.json();
      console.log(user_list);
      return user_list;
    })();*/
</script>

Push

<style>
    .avatar {
        max-width: 200px;
    }
</style>
